var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f88be120-e228-4e82-b7ea-9cc753ab1741",
    x1: 12.3,
    y1: 0.49,
    x2: 12.3,
    y2: 17.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba0a489b-e6fc-478b-a844-ae016f2be8bf",
    x1: 9.48,
    y1: 17.51,
    x2: 9.48,
    y2: 9.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#29bade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2ec9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32d4f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b1186d34-5ca3-4e43-992d-40ecef5e891b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.68.49H7.92a.57.57,0,0,0-.57.56V13.53a10.47,10.47,0,0,1,1.42-1h1.66l.92,1.22V15.6l-1.16.84-1.61-.2L7.35,15.08v1.69a.57.57,0,0,0,.57.56h8.76a.56.56,0,0,0,.56-.56V1.05A.56.56,0,0,0,16.68.49Z",
    fill: "url(#f88be120-e228-4e82-b7ea-9cc753ab1741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af47f827-8b1b-4acd-8974-8eafe35490c9",
    d: "M8.66,2.24h1.61a.14.14,0,0,1,.14.14V4.46a.14.14,0,0,1-.14.14H8.66a.14.14,0,0,1-.14-.14V2.38A.14.14,0,0,1,8.66,2.24Zm2.83,0H13.1a.14.14,0,0,1,.14.14V4.46a.14.14,0,0,1-.14.14H11.49a.14.14,0,0,1-.14-.14V2.38A.14.14,0,0,1,11.49,2.24Zm2.84,0h1.61a.14.14,0,0,1,.14.14V4.46a.14.14,0,0,1-.14.14H14.33a.14.14,0,0,1-.14-.14V2.38A.14.14,0,0,1,14.33,2.24ZM8.66,6h1.61a.14.14,0,0,1,.14.14V8.24a.14.14,0,0,1-.14.14H8.66a.14.14,0,0,1-.14-.14V6.16A.14.14,0,0,1,8.66,6Zm2.83,0H13.1a.14.14,0,0,1,.14.14V8.24a.14.14,0,0,1-.14.14H11.49a.14.14,0,0,1-.14-.14V6.16A.14.14,0,0,1,11.49,6Zm2.84,0h1.61a.14.14,0,0,1,.14.14V8.24a.14.14,0,0,1-.14.14H14.33a.14.14,0,0,1-.14-.14V6.16A.14.14,0,0,1,14.33,6ZM8.66,9.8h1.61a.14.14,0,0,1,.14.14V12a.14.14,0,0,1-.14.14H8.66A.14.14,0,0,1,8.52,12V9.94A.14.14,0,0,1,8.66,9.8Zm2.83,0H13.1a.14.14,0,0,1,.14.14V12a.14.14,0,0,1-.14.14H11.49a.14.14,0,0,1-.14-.14V9.94A.14.14,0,0,1,11.49,9.8Zm0,3.78H13.1a.14.14,0,0,1,.14.14V16.8a.14.14,0,0,1-.14.14H11.49a.14.14,0,0,1-.14-.14V13.72A.14.14,0,0,1,11.49,13.58ZM14.33,9.8h1.61a.14.14,0,0,1,.14.14V12a.14.14,0,0,1-.14.14H14.33a.14.14,0,0,1-.14-.14V9.94A.14.14,0,0,1,14.33,9.8Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,13A1.3,1.3,0,0,0,8.26,14H3.76a2.82,2.82,0,0,0-.08.65v.06H8.26A1.29,1.29,0,1,0,9.5,13Z",
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12.46A3.26,3.26,0,0,0,9.6,9.35a3.34,3.34,0,0,0-3.2,2.18,3.18,3.18,0,0,0-2.54,2H8A1.72,1.72,0,1,1,9.5,16a1.73,1.73,0,0,1-1.53-1H3.75a3.2,3.2,0,0,0,3.18,2.42h5.54l.14,0A2.63,2.63,0,0,0,15.21,15,2.6,2.6,0,0,0,13,12.46Z",
    fill: "url(#ba0a489b-e6fc-478b-a844-ae016f2be8bf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,13A1.3,1.3,0,0,0,8.26,14H3.76a2.22,2.22,0,0,1-.47-.06,2.32,2.32,0,0,1-1.82-2.19A2.33,2.33,0,0,1,3.54,9.46l.22,0,.07-.2A2.56,2.56,0,0,1,6.29,7.55,2.64,2.64,0,0,1,8.57,8.82a3.08,3.08,0,0,1,.75-.09,3.32,3.32,0,0,0-3-1.89A3.28,3.28,0,0,0,3.23,8.79,3,3,0,0,0,.76,11.71,3,3,0,0,0,3,14.55H3a2,2,0,0,0,.73.12H8.26A1.29,1.29,0,1,0,9.5,13Z",
    fill: "#50e6ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.d8a3c2e14aa16039bc634946e06b6cde.svg";
export { ForwardRef as ReactComponent };